import { InputAdornment, TextField } from "@mui/material";
import { ChangeEvent, FC } from "react";
import { SearchOutlined } from "@mui/icons-material";

interface SearchProps {
  value: string;
  onChange: (value: string) => void;
}

const Search: FC<SearchProps> = ({ value, onChange }) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };
  return (
    <TextField
      type="text"
      placeholder="Search"
      value={value}
      onChange={handleChange}
      sx={{ width: 150 }}
      size="small"
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <SearchOutlined />
            </InputAdornment>
          ),
        },
      }}
    />
  );
};

export { Search };
